// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ZAILy","title":"Header_title__wUfPr","left":"Header_left__2l8vr","clinicName":"Header_clinicName__1Z02e"};